import { render, staticRenderFns } from "./News_detail.vue?vue&type=template&id=d5df1ada"
import script from "./News_detail.vue?vue&type=script&lang=js"
export * from "./News_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports